var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCvc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Img - CVC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1396 2.16406H2.15203C1.45139 2.16406 0.628906 2.97148 0.628906 3.6875V15.1133C0.628906 15.8293 1.45139 16.6367 2.15203 16.6367H21.1911C21.8917 16.6367 22.7142 15.8293 22.7142 15.1133V9.37754C22.0727 9.95477 21.2803 10.3378 20.4295 10.482V10.543C20.4295 11.0457 20.1554 11.3047 19.668 11.3047H2.91359C2.42619 11.3047 2.15203 11.0457 2.15203 10.543V9.78125C2.15203 9.27852 2.42619 9.01953 2.91359 9.01953H16.2638C15.8242 8.53224 15.495 7.95569 15.2989 7.32934C15.1028 6.703 15.0443 6.04166 15.1275 5.39061C15.2107 4.73956 15.4335 4.11417 15.7808 3.55728C16.1281 3.00038 16.5916 2.52513 17.1396 2.16406Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3575 4.44922H0.628906V6.73438H15.1595C15.0316 5.96815 15.0997 5.182 15.3575 4.44922Z",
    fill: "#565656"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6669 11.3047C18.253 11.3047 16.8971 10.7429 15.8973 9.74297C14.8976 8.74302 14.3359 7.3868 14.3359 5.97266C14.3359 4.55851 14.8976 3.20229 15.8973 2.20234C16.8971 1.20239 18.253 0.640625 19.6669 0.640625C21.0807 0.640625 22.4367 1.20239 23.4364 2.20234C24.4362 3.20229 24.9978 4.55851 24.9978 5.97266C24.9978 7.3868 24.4362 8.74302 23.4364 9.74297C22.4367 10.7429 21.0807 11.3047 19.6669 11.3047ZM17.5497 3.76367H16.9481L15.4783 4.51016V5.27187L16.6435 4.6625V8.18164H17.5573V3.76367H17.5497ZM19.3013 4.37305C19.7354 4.37305 20.04 4.6168 20.04 4.96719C20.04 5.34805 19.6821 5.61465 19.1642 5.61465H18.9358V6.26211H19.2099C19.7583 6.26211 20.1314 6.53633 20.1314 6.93242C20.1314 7.31328 19.7659 7.57227 19.248 7.57227C18.8672 7.57227 18.4865 7.45039 18.0904 7.21426V7.97598C18.5169 8.15879 18.9434 8.25781 19.3623 8.25781C20.3599 8.25781 21.0453 7.74746 21.0453 7.00859C21.0453 6.49062 20.7254 6.07168 20.1924 5.9041C20.6493 5.75176 20.9463 5.34805 20.9463 4.89102C20.9463 4.175 20.3142 3.6875 19.4003 3.6875C18.9884 3.69207 18.5816 3.78018 18.2047 3.94648V4.69297C18.5702 4.4873 18.9434 4.37305 19.3013 4.37305ZM22.5913 6.03359C23.1472 6.03359 23.5356 6.36113 23.5356 6.78769C23.5356 7.23711 23.1472 7.54941 22.5913 7.54941C22.2562 7.54941 21.9059 7.44277 21.5479 7.22188V8.00645C21.9211 8.17402 22.3019 8.25781 22.675 8.25781C22.8731 8.25781 23.0558 8.22734 23.231 8.18164C23.627 7.53418 23.8555 6.7877 23.8555 5.98789L23.8402 5.66797C23.5571 5.50033 23.2324 5.41586 22.9035 5.42422C22.7664 5.42422 22.6217 5.43184 22.4694 5.45469V4.46445H23.5661C23.471 4.22064 23.3537 3.98606 23.2158 3.76367H21.6774V6.16309C21.982 6.08691 22.2867 6.03359 22.5913 6.03359Z",
    fill: "#565656"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvc);
export default __webpack_public_path__ + "static/media/cvc.70f42c1fd068e5631f3c9c86ce908a27.svg";
export { ForwardRef as ReactComponent };